import { format, isValidNumber, NumberFormat } from "libphonenumber-js";
format 
export default {
  formatDisplay: (number) => {
    return number
      ? format(number, "National" as NumberFormat)
      : number;
  },

  formatDial: (number) => {
    return number
      ? format(number, "RFC3966" as NumberFormat)
      : number;
  },

  isValid: (number) => isValidNumber(number, "US" as NumberFormat)
};
